import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../layout/admin.css';
import config from '../../../config/config'

import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  
  const logout = () => {
    try {
      localStorage.clear();
      navigate(0);
    } catch (err) {
      console.error("Logout failed", err);
    }

  }
  return (
    <div className='main-header'>
      <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
        <div className="container">


          <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
            {/* Search for mobile */}
            <li className="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none">
              <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" aria-haspopup="true">
                <i className="fa fa-search"></i>
              </a>
              <ul className="dropdown-menu dropdown-search animated fadeIn">
                <form className="navbar-left navbar-form nav-search">
                  <div className="input-group">
                    <input type="text" placeholder="Search ..." className="form-control" />
                  </div>
                </form>
              </ul>
            </li>

            {/* Messages */}
            <li className="nav-item topbar-icon dropdown hidden-caret">
              {/* <a className="nav-link dropdown-toggle" href="#" id="messageDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-envelope"></i>
            </a> */}
              <ul className="dropdown-menu messages-notif-box animated fadeIn" aria-labelledby="messageDropdown">
                <li>
                  <div className="dropdown-title d-flex justify-content-between align-items-center">
                    Messages
                    <a href="#" className="small">Mark all as read</a>
                  </div>
                </li>
                <li>
                  <div className="scroll-wrapper message-notif-scroll scrollbar-outer" style={{ position: 'relative' }}>
                    <div className="message-notif-scroll scrollbar-outer scroll-content" style={{ height: 'auto', marginBottom: '0px', marginRight: '0px', maxHeight: '0px' }}>
                      <div className="notif-center">
                        {/* Multiple message items */}
                        <a href="#">
                          <div className="notif-img">
                            <img src="/../assets/img/jm_denis.jpg" alt="Img Profile" />
                          </div>
                          <div className="notif-content">
                            <span className="subject">Jimmy Denis</span>
                            <span className="block"> How are you ? </span>
                            <span className="time">5 minutes ago</span>
                          </div>
                        </a>
                        {/* Add more messages as needed */}
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a className="see-all" href="javascript:void(0);">See all messages <i className="fa fa-angle-right"></i></a>
                </li>
              </ul>
            </li>

            {/* Notifications */}
            <li className="nav-item topbar-icon dropdown hidden-caret">
              {/* <a className="nav-link dropdown-toggle" href="#" id="notifDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-bell"></i>
              <span className="notification">4</span>
            </a> */}
              <ul className="dropdown-menu notif-box animated fadeIn" aria-labelledby="notifDropdown">
                <li>
                  <div className="dropdown-title">
                    You have 4 new notifications
                  </div>
                </li>
                <li>
                  <div className="scroll-wrapper notif-scroll scrollbar-outer" style={{ position: 'relative' }}>
                    <div className="notif-scroll scrollbar-outer scroll-content" style={{ height: 'auto', marginBottom: '0px', marginRight: '0px', maxHeight: '0px' }}>
                      <div className="notif-center">
                        {/* Notification items */}
                        <a href="#">
                          <div className="notif-icon notif-primary">
                            <i className="fa fa-user-plus"></i>
                          </div>
                          <div className="notif-content">
                            <span className="block">New user registered</span>
                            <span className="time">5 minutes ago</span>
                          </div>
                        </a>
                        {/* Add more notifications as needed */}
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a className="see-all" href="javascript:void(0);">See all notifications <i className="fa fa-angle-right"></i></a>
                </li>
              </ul>
            </li>

      
            {/* User Profile */}
            <li className="nav-item topbar-user dropdown hidden-caret">
              <a className="dropdown-toggle profile-pic" data-bs-toggle="dropdown" href="#" aria-expanded="false">
                <div className="avatar-sm">
                  <img src={`${config.BASE_URL}/uploads/users/${localStorage.getItem('userImage')}`} alt="..." className="avatar-img rounded-circle" />
                </div>
                <span className="profile-username">
                  <span className="op-7">Hi,</span>
                  <span className="fw-bold">{localStorage.getItem('userName')}</span>
                </span>
              </a>
              <ul className="dropdown-menu dropdown-user animated fadeIn">
                <div className="scroll-wrapper dropdown-user-scroll scrollbar-outer" style={{ position: 'relative' }}>
                  <div className="dropdown-user-scroll scrollbar-outer scroll-content" style={{ height: 'auto', marginBottom: '0px', marginRight: '0px', maxHeight: '0px' }}>
                    <li>
                      <div className="user-box">
                        <div className="avatar-lg">
                          <img src={`${config.BASE_URL}/uploads/users/${localStorage.getItem('userImage')}`} alt="image profile" className="avatar-img rounded" />
                        </div>
                        <div className="u-text">
                          <h4>{localStorage.getItem('userName')}</h4>
                          <p className="text-muted">{localStorage.getItem('userEmail')}</p>
                          {/* <a href="profile.html" className="btn btn-xs btn-secondary btn-sm">View Profile</a> */}
                        </div>
                      </div>
                    </li>
                    <li>
                      {/* <div className="dropdown-divider"></div>
                      <a className="dropdown-item" href="#">My Profile</a>
                      <a className="dropdown-item" href="#">My Balance</a>
                      <a className="dropdown-item" href="#">Inbox</a>
                      <div className="dropdown-divider"></div>
                      <a className="dropdown-item" href="#">Account Setting</a> */}
                      <div className="dropdown-divider"></div>
                      <a className="dropdown-item" style={{ cursor: "pointer" }} onClick={()=>logout()}>Logout</a>
                    </li>
                  </div>
                </div>
              </ul>
            </li>

          </ul>
        </div>
      </nav>
    </div>

  );
}

export default Header;
